var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Word Doc Icon 1",
    clipPath: "url(#clip0_394_517)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Word-Doc-Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3643 22.8925C21.3643 23.4827 20.8859 23.9611 20.2956 23.9611H5.17695C4.58666 23.9611 4.10823 23.4827 4.10823 22.8925V3.01339C4.10823 2.42321 4.58666 1.94478 5.17695 1.94478H14.1959V7.24344C14.1959 7.64896 14.5246 7.97766 14.9301 7.97766H21.3643V22.8925ZM21.3643 7.01364L15.4766 1.94478L14.2545 0.892578H14.1959H5.17695C4.00743 0.892578 3.05603 1.84398 3.05603 3.01339V22.8925C3.05603 24.0619 4.00743 25.0133 5.17695 25.0133H20.2956C21.4651 25.0133 22.4165 24.0619 22.4165 22.8925V7.97766V7.91948L21.3643 7.01364Z",
    fill: "#2B5AB5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.89523 21.2106C1.21652 21.2106 0.666504 20.6604 0.666504 19.9817V11.9865C0.666504 11.3079 1.21652 10.7578 1.89523 10.7578H9.89049C10.5691 10.7578 11.1192 11.3079 11.1192 11.9865V19.9817C11.1192 20.6604 10.5691 21.2106 9.89049 21.2106H1.89523Z",
    fill: "#2B5AB5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9216 13.55L4.52983 16.1883L4.66226 16.9225L4.79522 16.2033L5.31547 13.55H6.33126L6.87874 16.1879L7.01891 16.9225L7.16109 16.2164L7.77532 13.55H8.75534L7.45933 18.157H6.53765L5.98123 15.4628L5.81876 14.5721L5.65629 15.4628L5.09987 18.157H4.20582L2.89954 13.55H3.9216Z",
    fill: "#FEFEFE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_394_517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.913,
    height: 24,
    fill: "white",
    transform: "translate(0.530518 0.892578)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDocIcon);
export default __webpack_public_path__ + "static/media/new-doc-icon.0defd3a68c422186095594916d476057.svg";
export { ForwardRef as ReactComponent };